import {Injectable, inject} from '@angular/core';
import {Router, CanActivateFn} from '@angular/router';
import {AppService} from '@services/app.service';

export const authGuard: CanActivateFn = (route, state) => {
    const authService = inject(AppService);
    const router = inject(Router);

    const isAuthenticated = authService.isLoggedIn();
    const domain = window.location.hostname;
    const isMainDomain = domain === 'smartpoultary.ai:9090'; // main domain
    const isSubDomain = domain.split('.').length > 2; // Subdomains

    if (!isAuthenticated) {
        if (isSubDomain) {
            router.navigate(['/login']);
        } else {
            router.navigate(['/onboarding']);
        }
    }
    return isAuthenticated;
};
